import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { Divider as Component } from '@wix/wix-ui-tpa/cssVars';
import { classes } from './TitleDivider.st.css';

export const TitleDivider = () => (
  <Component className={classes.root} data-hook={VIEWER_HOOKS.TITLE_DIVIDER} direction="horizontal" />
);
